import React from "react";
import './clicker-assessment-leaderboard.scss';
import leaderBoardDisplaySound from "../../../assets/audio/elo_cleared.mp3";
import noLeaderBoardSound from '../../../assets/audio/failure_audio.mp3';
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";

class ClickerAssessmentLeaderboard extends React.Component {


    state = {
        // leaderboardData: [
        //     {
        //         "_id": "66f53ed8b97d6172dba99964",
        //         "assessmentActivityId": "66f53ed23315456b8a678529",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 30,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 1,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "1000.1000",
        //         "timeTakenInMilliSecond": 8740,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a8",
        //         "rank": 1,
        //         markScored: 20,
        //         studentNumber :1
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99963",
        //         "assessmentActivityId": "66f53ed23315456b8a678528",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 1,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 2,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.03",
        //         "timeTakenInMilliSecond": 1662,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "rank": 2,
        //         markScored: 20,
        //         studentNumber :2
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99964",
        //         "assessmentActivityId": "66f53ed23315456b8a678529",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 2,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 1,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.15",
        //         "timeTakenInMilliSecond": 8740,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a8",
        //         "rank": 3,
        //         markScored: 20,
        //         studentNumber :3
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99963",
        //         "assessmentActivityId": "66f53ed23315456b8a678528",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 1,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 2,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.03",
        //         "timeTakenInMilliSecond": 1662,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "rank": 4,
        //         markScored: 20,
        //         studentNumber :4
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99964",
        //         "assessmentActivityId": "66f53ed23315456b8a678529",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 2,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 1,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.15",
        //         "timeTakenInMilliSecond": 8740,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a8",
        //         "rank": 5,
        //         markScored: 20,
        //         studentNumber :5
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99963",
        //         "assessmentActivityId": "66f53ed23315456b8a678528",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 1,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 2,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.03",
        //         "timeTakenInMilliSecond": 1662,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "rank": 6,
        //         markScored: 20,
        //         studentNumber :6
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99964",
        //         "assessmentActivityId": "66f53ed23315456b8a678529",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 2,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 1,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.15",
        //         "timeTakenInMilliSecond": 8740,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a8",
        //         "rank": 7,
        //         studentNumber :7
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99963",
        //         "assessmentActivityId": "66f53ed23315456b8a678528",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 1,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 2,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.03",
        //         "timeTakenInMilliSecond": 1662,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "rank": 8,
        //         studentNumber :8
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99964",
        //         "assessmentActivityId": "66f53ed23315456b8a678529",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 2,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 1,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.15",
        //         "timeTakenInMilliSecond": 8740,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a8",
        //         "rank": 9,
        //         studentNumber :9
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99963",
        //         "assessmentActivityId": "66f53ed23315456b8a678528",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 1,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 2,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.03",
        //         "timeTakenInMilliSecond": 1662,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "rank": 10,
        //         studentNumber :10
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99964",
        //         "assessmentActivityId": "66f53ed23315456b8a678529",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 2,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 1,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.15",
        //         "timeTakenInMilliSecond": 8740,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a8",
        //         "rank": 11,
        //         studentNumber :11
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99963",
        //         "assessmentActivityId": "66f53ed23315456b8a678528",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 1,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 2,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.03",
        //         "timeTakenInMilliSecond": 1662,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "rank": 12,
        //         studentNumber :12
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99964",
        //         "assessmentActivityId": "66f53ed23315456b8a678529",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 2,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 1,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.15",
        //         "timeTakenInMilliSecond": 8740,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a8",
        //         "rank": 13,
        //         studentNumber :13
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99963",
        //         "assessmentActivityId": "66f53ed23315456b8a678528",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 1,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 2,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.03",
        //         "timeTakenInMilliSecond": 1662,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "rank": 14,
        //         studentNumber :14
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99964",
        //         "assessmentActivityId": "66f53ed23315456b8a678529",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 2,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 1,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.15",
        //         "timeTakenInMilliSecond": 8740,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a8",
        //         "rank": 15,
        //         studentNumber :15
        //     },
        //     {
        //         "_id": "66f53ed8b97d6172dba99963",
        //         "assessmentActivityId": "66f53ed23315456b8a678528",
        //         "board": "CBSE",
        //         "class": "Class 6",
        //         "correctQuestionCount": 1,
        //         "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //         "incorrectQuestionCount": 2,
        //         "name": "Team A",
        //         "notAttemptedQuestionCount": 0,
        //         "timeTaken": "0.03",
        //         "timeTakenInMilliSecond": 1662,
        //         "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "rank": 16,
        //         studentNumber :16
        //     },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Team A",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Countingwell School School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Countingwell School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Countingwell School School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Countingwell School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Countingwell School School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Countingwell School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Countingwell School School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Countingwell School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Countingwell School School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Countingwell School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Countingwell School School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Countingwell School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Countingwell School School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99964",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678529",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 2,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 1,
        //     //     "name": "Countingwell School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.15",
        //     //     "timeTakenInMilliSecond": 8740,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a8",
        //     //     "rank": 1
        //     // },
        //     // {
        //     //     "_id": "66f53ed8b97d6172dba99963",
        //     //     "assessmentActivityId": "66f53ed23315456b8a678528",
        //     //     "board": "CBSE",
        //     //     "class": "Class 6",
        //     //     "correctQuestionCount": 1,
        //     //     "countingwellLastUpdateTimestamp": "2024-09-26T11:00:54.530Z",
        //     //     "incorrectQuestionCount": 2,
        //     //     "name": "Countingwell School School",
        //     //     "notAttemptedQuestionCount": 0,
        //     //     "timeTaken": "0.03",
        //     //     "timeTakenInMilliSecond": 1662,
        //     //     "transferKey": "USER_BULK_IMPORT_8_1_2024",
        //     //     "userId": "659b90fa21cb4f53081b46a7",
        //     //     "rank": 2
        //     // }
        // ],
        leaderboardData: this.props.leaderboardData,
        flippedRanks: {},
        isReload: true,
        gifSrc: getImageSource(ImageConstants.CHAPTER_COMPLETED_GIF)
    }

    constructor(props) {
        super(props)
        this.audio = new Audio(leaderBoardDisplaySound)
        this.failureAudio = new Audio(noLeaderBoardSound)
    }


    componentDidMount() {
        if (this.state.leaderboardData.length) {
            this.setState({ isReload: false }, () => {
                this.setState({ isReload: true })
            })
            this.playSound()
        } else {
            this.playNoLeaderboardSound()
        }
        this.state.leaderboardData.forEach((_, index) => {
            setTimeout(() => {
                this.setState((prevState) => ({
                    flippedRanks: { ...prevState.flippedRanks, [index]: true },
                }));
            }, index * 200); // Delay each flip by 500ms
        });
    }

    playSound = () => {
        // this.setState({gifSrc : ''}, () => {
        //     setTimeout(() => this.setState({gifSrc : getImageSource(ImageConstants.CHAPTER_COMPLETED_GIF)}), 100); 
        // })



        this.audio.play().catch((error) => {
            console.error("Error playing the sound:", error);
        });
    };

    playNoLeaderboardSound() {
        this.failureAudio.play().catch((error) => {
            console.error("Error playing the sound:", error);
        });
    }


    renderMoreThanTenLeaderboard() {



        if (this.state.leaderboardData.length > 10) {
            return (
                

                    this.state.leaderboardData.length ?
                        <div className="row-modified mt-1">
                            <div className="col">
                                {
                                    this.state.leaderboardData.slice(0, Math.ceil(this.state.leaderboardData.length / 2)).map((item, index) => (
                                        <div className={`row ${this.state.flippedRanks[index] ? "flip-in" : "flip-hidden"
                                            }`} style={{ width: '98%' }}>
                                            {/* <div className="col-2 rank-wrapper d-flex justify-content-center align-items-center">
                                    {
                                        this.props.isFinalQuestion && index <= 1 ? <div>{"Q"}</div> : <div>{item.rank}</div>
                                    }
                                </div> */}
                                            {/* <div className="col-2 rank-wrapper d-flex justify-content-center align-items-center">
                                    {
                                        <div>{item.rank}</div>
                                    }
                                </div> */}
                                            <div className={`score-item col row ${this.state.leaderboardData.length > 5 ? 'less-padding' : ''}`}
                                                key={index}
                                                style={{ backgroundColor: "#003478" }}
                                            >
                                                {/* <span className="rank">{index + 1}</span> */}
                                                {/* <div className="d-flex align-items-center">
                                        <div className="circle-wrapper">
                                            <div className="inner-circle">
                                                {item.rank}
                                            </div>
                                            <img className="blue_flag_icon" src={getImageSource(ImageConstants.BLUE_FLAG_ICON)} />
                                        </div>
                                        <div className="name">{item.name}{` (${item.studentNumber})`}</div>
                                    </div> */}
                                                <div className="d-flex align-items-center col">
                                                    <div className="image-wrapper">
                                                        {/* <img className="rank-image-size" src={getImageSource(item.rank === 1 ? ImageConstants.RANK_ONE :
                                                item.rank === 2 ? ImageConstants.RANK_TWO : item.rank === 3 ? ImageConstants.RANK_THREE : ImageConstants.RANK_OTHERS)} />
                                            {
                                                item.rank >= 4 ?

                                                    <div className={`${item.rank > 9 ? 'rank-text-for-more-than-nine' : 'rank-text'}`}>{item.rank}</div>

                                                    :
                                                    <></>
                                            } */}
                                                        <span className="shield"><span className="number">{item.rank}</span></span>
                                                    </div>

                                                    <div className="name">{item.name}{` (${item.studentNumber})`}</div>
                                                </div>
                                                {/* <span className="correct-question-count">{item.correctQuestionCount}</span> */}
                                                {
                                                    item.timeTaken ?
                                                        <>
                                                            <div className="score col-2">
                                                                <img className="clock-image-size " src={getImageSource(ImageConstants.NEW_BLACK_TICK_ICON)} />  <span className="px-1">{item.markScored / 10}</span>

                                                            </div>
                                                            <span className="px-1 divider-colour">|</span>
                                                            <div className="score-time col-4">
                                                                <img className="clock-image-size " src={getImageSource(ImageConstants.NEW_BLACK_CLOCK_ICON)} /> <span className="px-1">{item.timeTaken} s</span>

                                                            </div>
                                                        </>

                                                        : <></>
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>

                            <div className="col">
                                {
                                    this.state.leaderboardData.slice(Math.ceil(this.state.leaderboardData.length / 2)).map((item, index) => (
                                        <div className={`row ${this.state.flippedRanks[index] ? "flip-in" : "flip-hidden"
                                            }`} style={{ width: '98%' }}>
                                            {/* <div className="col-2 rank-wrapper d-flex justify-content-center align-items-center">
                                    {
                                        this.props.isFinalQuestion && index <= 1 ? <div>{"Q"}</div> : <div>{item.rank}</div>
                                    }
                                </div> */}
                                            {/* <div className="col-2 rank-wrapper d-flex justify-content-center align-items-center">
                                    {
                                        <div>{item.rank}</div>
                                    }
                                </div> */}
                                            <div className={`score-item col row ${this.state.leaderboardData.length > 5 ? 'less-padding' : ''}`}
                                                key={index}
                                                style={{ backgroundColor: "#003478" }}
                                            >
                                                {/* <span className="rank">{index + 1}</span> */}
                                                {/* <div className="d-flex align-items-center">
                                        <div className="circle-wrapper">
                                            <div className="inner-circle">
                                                {item.rank}
                                            </div>
                                            <img className="blue_flag_icon" src={getImageSource(ImageConstants.BLUE_FLAG_ICON)} />
                                        </div>
                                        <div className="name">{item.name}{` (${item.studentNumber})`}</div>
                                    </div> */}
                                                <div className="d-flex align-items-center col">
                                                    <div className="image-wrapper">
                                                        {/* <img className="rank-image-size" src={getImageSource(item.rank === 1 ? ImageConstants.RANK_ONE :
                                                item.rank === 2 ? ImageConstants.RANK_TWO : item.rank === 3 ? ImageConstants.RANK_THREE : ImageConstants.RANK_OTHERS)} />
                                            {
                                                item.rank >= 4 ?

                                                    <div className={`${item.rank > 9 ? 'rank-text-for-more-than-nine' : 'rank-text'}`}>{item.rank}</div>

                                                    :
                                                    <></>
                                            } */}
                                                        <span className="shield"><span className="number">{item.rank}</span></span>
                                                    </div>

                                                    <div className="name">{item.name}{` (${item.studentNumber})`}</div>
                                                </div>
                                                {/* <span className="correct-question-count">{item.correctQuestionCount}</span> */}
                                                {
                                                    item.timeTaken ?
                                                        <>
                                                            <div className="score col-2">
                                                                <img className="clock-image-size " src={getImageSource(ImageConstants.NEW_BLACK_TICK_ICON)} />  <span className="px-1">{item.markScored / 10}</span>

                                                            </div>
                                                            <span className="px-1 divider-colour">|</span>
                                                            <div className="score-time col-4">
                                                                <img className="clock-image-size " src={getImageSource(ImageConstants.NEW_BLACK_CLOCK_ICON)} /> <span className="px-1">{item.timeTaken} s</span>

                                                            </div>
                                                        </>

                                                        : <></>
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>

                        </div>


                        :
                        <div className="text-center no-leaderboard-text">No leaderboard</div>
                    
                



            )
        }
    }



    render() {


        if (this.state.leaderboardData.length > 10) {
            return <div className="clicker-assessment-leaderboard-v1">
                {
                    this.state.leaderboardData.length && this.state.isReload ?
                        <div key={Date.now()} className="position-relative">
                            {
                                <div className="chapter-completed-gif">
                                    <img src={this.state.gifSrc} />
                                </div>
                            }
                        </div>
                        :
                        <></>
                }
            {this.renderMoreThanTenLeaderboard()}
            </div>
        }

        return (
            <div className="clicker-assessment-leaderboard-v1">
                {
                    this.state.leaderboardData.length && this.state.isReload ?
                        <div key={Date.now()} className="position-relative">
                            {
                                <div className="chapter-completed-gif">
                                    <img src={this.state.gifSrc} />
                                </div>
                            }
                        </div>
                        :
                        <></>
                }

                <div className="score-board mt-1">
                    {this.state.leaderboardData.length ?
                        this.state.leaderboardData.map((item, index) => (
                            <div className={`row ${this.state.flippedRanks[index] ? "flip-in" : "flip-hidden"
                                }`} style={{ width: '98%' }}>
                                {/* <div className="col-2 rank-wrapper d-flex justify-content-center align-items-center">
                                    {
                                        this.props.isFinalQuestion && index <= 1 ? <div>{"Q"}</div> : <div>{item.rank}</div>
                                    }
                                </div> */}
                                {/* <div className="col-2 rank-wrapper d-flex justify-content-center align-items-center">
                                    {
                                        <div>{item.rank}</div>
                                    }
                                </div> */}
                                <div className={`score-item col row ${this.state.leaderboardData.length > 5 ? 'less-padding' : ''}`}
                                    key={index}
                                    style={{ backgroundColor: "#003478" }}
                                >
                                    {/* <span className="rank">{index + 1}</span> */}
                                    {/* <div className="d-flex align-items-center">
                                        <div className="circle-wrapper">
                                            <div className="inner-circle">
                                                {item.rank}
                                            </div>
                                            <img className="blue_flag_icon" src={getImageSource(ImageConstants.BLUE_FLAG_ICON)} />
                                        </div>
                                        <div className="name">{item.name}{` (${item.studentNumber})`}</div>
                                    </div> */}
                                    <div className="d-flex align-items-center col">
                                        <div className="image-wrapper">
                                            {/* <img className="rank-image-size" src={getImageSource(item.rank === 1 ? ImageConstants.RANK_ONE :
                                                item.rank === 2 ? ImageConstants.RANK_TWO : item.rank === 3 ? ImageConstants.RANK_THREE : ImageConstants.RANK_OTHERS)} />
                                            {
                                                item.rank >= 4 ?

                                                    <div className={`${item.rank > 9 ? 'rank-text-for-more-than-nine' : 'rank-text'}`}>{item.rank}</div>

                                                    :
                                                    <></>
                                            } */}
                                            <span className="shield"><span className="number">{item.rank}</span></span>
                                        </div>

                                        <div className="name">{item.name}{` (${item.studentNumber})`}</div>
                                    </div>
                                    {/* <span className="correct-question-count">{item.correctQuestionCount}</span> */}
                                    {
                                        item.timeTaken ?
                                            <>
                                                <div className="score col-auto">
                                                    <img className="clock-image-size " src={getImageSource(ImageConstants.NEW_BLACK_TICK_ICON)} />  <span className="px-1">{item.markScored / 10}</span>

                                                </div>
                                                <span className="px-1 divider-colour">|</span>
                                                <div className="score-time col-auto">
                                                    <img className="clock-image-size " src={getImageSource(ImageConstants.NEW_BLACK_CLOCK_ICON)} /> <span className="px-1">{item.timeTaken} s</span>

                                                </div>
                                            </>

                                            : <></>
                                    }
                                </div>
                            </div>
                        ))
                        :
                        <div className="text-center no-leaderboard-text">No leaderboard</div>
                    }
                </div>
            </div>
        )
    }

}

export default ClickerAssessmentLeaderboard;

